import actionTypes from './actionTypes';

const requestTeamStory = (args, partyKey) => ({
    type: actionTypes.REQUEST_TEAM_STORY,
    payload: {
        args,
        partyKey,
    },
});

const teamStoryResponse = (success, errors, response, partyKey) => ({
    type: actionTypes.TEAM_STORY_RESPONSE,
    payload: {
        success,
        errors,
        response,
        partyKey,
    },
});

const requestTeamStoryDetail = (args, partyKey) => ({
    type: actionTypes.REQUEST_TEAM_STORY_DETAIL,
    payload: {
        args,
        partyKey,
    },
});

const teamStoryDetailResponse = (success, errors, response, partyKey) => ({
    type: actionTypes.TEAM_STORY_DETAIL_RESPONSE,
    payload: {
        success,
        errors,
        response,
        partyKey,
    },
});

export default {
	requestTeamStory,
	teamStoryResponse,
	requestTeamStoryDetail,
	teamStoryDetailResponse,
};
